<template>
  <a-menu
      theme="light"
      mode="horizontal"
      :items="menuList"
      class="hono-menu"
      @click="handleEventClick"
  >
  </a-menu>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps({
  menuList:{
    type: Array,
    default: []
  },
})

const handleEventClick = (e) => {
  //用路由跳转
  router.push({
    path: e.item.path,
    // query: { id: 123, name: 'John' },
  });
}


</script>


<style scoped>
/* 增加选择器的特异性 */
:deep(.ant-menu) .ant-menu-item {
  border-inline-end: none !important; /* 对于垂直菜单 */
  border-bottom: none !important; /* 对于水平菜单 */
}
.hono-menu{
  background: #FFFFFF;
  height: 66px;
  line-height: 66px;
}
</style>